import {
  PMultiSelect,
  PMultiSelectOption,
  PMultiSelectProps,
  PSelect,
  PSelectOption,
  PSelectProps,
} from '@porsche-design-system/components-react';

import { Role } from '@/config/role';

type Filter = { _in: string[] };

export const RoleSelect = ({
  dataFilter,
  ...props
}: PSelectProps & { dataFilter?: Filter }) => {
  const options = Object.values(Role).map((role) => ({
    label: role,
    value: role,
  }));

  return (
    <PSelect {...props}>
      {options
        .filter(
          (option) => !dataFilter || dataFilter._in.includes(option.value),
        )
        .map(({ label, value }) => (
          <PSelectOption key={value} value={value}>
            {label}
          </PSelectOption>
        ))}
    </PSelect>
  );
};

export const MultiRoleSelect = ({
  dataFilter,
  ...props
}: PMultiSelectProps & { dataFilter?: Filter }) => {
  const options = Object.values(Role).map((role) => ({
    label: role,
    value: role,
  }));

  return (
    <PMultiSelect {...props}>
      {options
        .filter(
          (option) => !dataFilter || dataFilter._in.includes(option.value),
        )
        .map(({ label, value }) => (
          <PMultiSelectOption key={value} value={value}>
            {label}
          </PMultiSelectOption>
        ))}
    </PMultiSelect>
  );
};
